/* unplugin-vue-components disabled */import script from "./splitNavigationBar.vue?vue&type=script&lang=js"
export * from "./splitNavigationBar.vue?vue&type=script&lang=js"

import "./splitNavigationBar.vue?vue&type=style&index=0&id=55aa7669&lang=scss"

const __exports__ = script;

export default __exports__